export const digitsInfo: string = '1.0-2';
export const digitsInfoCurrency: string = '1.2-2';
